export const black = 'rgb(25, 31, 42)';
export const bgColor = 'rgb(226,232,240)';
export const bgColorInline = 'rgb(242,242,242)';
export const lightGray = 'rgb(202,205,209)';
export const mediumGray = 'rgb(150,155,164)';
export const darkGray = 'rgb(74,85,104)';
export const lightGreen = 'rgb(163, 221, 187)';
export const green = 'rgb(72,187,120)';
export const yellow = 'rgb(236,201,75)';
export const orange = 'rgb(247,147,30)';
export const red = 'rgb(245,101,101)';
export const blue = 'rgb(0,163,222)';
export const purple = 'rgb(90,103,216)';
export const textGray = 'rgb(113,128,150)';
export const white = 'rgb(255,255,255)';
